import { LocalStorageService } from "../services/LocalStorageService"
import { makeid } from "../utils/stringHelper"

export const useStoreInfo = () => {
  var deviceId = LocalStorageService.getObject("deviceId")
  var name = LocalStorageService.getObject("deviceId")

  if (!deviceId) {
    deviceId = makeid(20)
    LocalStorageService.setObject("deviceId", deviceId)
  }

  return deviceId
}
